module.exports = __webpack_public_path__ + "img/homepage-quick-links-boxes-arrows-mitsu.1278bcc3.png";